export const getUnderlyingLiveFeed = (state) => state.underlyingLiveFeed.data;
export const getUnderlyingLiveFeedClosePrices = (state) =>
  state.underlyingLiveFeed.underlyingClosePrices;
export const getUnderlyingLiveFeedUnderlyingData = (state) =>
  state.underlyingLiveFeed.underlyingData;
